//@ts-check

import React, { createContext, useMemo } from 'react';
import map from 'lodash/map';
import flatten from 'lodash/flatten';
import { useUser } from 'hooks';

/**
 * @type {React.Context<Set<string>>}
 */
export const PermissionContext = createContext(new Set());

const PermissionWrapper = ({ children }) => {
  const auth = useUser();

  const allowedPermissions = useMemo(() => {
    if (!auth || !auth.userType) return new Set();

    /**
     * @type {import('api/userApi').UserType | null}
     */
    let userTypes = null;

    try {
      userTypes = JSON.parse(auth.userType);
    } catch (error) {
      console.error('Invalid JSON in userType:', auth.userType, error);
      return new Set(); // Return an empty set to avoid breaking
    }

    if (!userTypes || !userTypes.userTypeUnits) return new Set();

    return new Set(
      flatten(
        map(userTypes.userTypeUnits, (unit) =>
          map(
            unit.routes,
            (routeData) =>
              `${(unit.name || '').toUpperCase()}-${unit.role}-${(
                routeData.method ||
                routeData.name ||
                ''
              ).toUpperCase()}-${routeData.route}`,
          ),
        ),
      ),
    );
  }, [auth]);

  return (
    <PermissionContext.Provider value={allowedPermissions}>
      {children}
    </PermissionContext.Provider>
  );
};

export default PermissionWrapper;
